import { create } from 'zustand';

interface ModalStoreState {
  playerModalId: string | null;
  isPlayerModalOpen: boolean;
  setIsPlayerModalOpen: (value: string | null) => void;
}

export const useModalsStore = create<ModalStoreState>(set => ({
  playerModalId: null,
  isPlayerModalOpen: false,
  setIsPlayerModalOpen: (value: string | null) =>
    set({ playerModalId: value, isPlayerModalOpen: !!value }),
}));
